import Box from "@/common/components/Box";

const EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse = () => {
  return (
    <Box className="p-0 flex items-center justify-center h-80 overflow-hidden">
      <div className="flex w-full flex-col items-center justify-center gap-6 h-80">
        <div>
          <img src="/search-1.gif" className="h-40" />
        </div>

        <div>
          <p className="text-base font-bold text-center">
            Aguardando envio da sua proposta
          </p>
        </div>
      </div>
    </Box>
  );
}

export default EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse;
